/**
 * Who currently gets the features that are still being piloted.
 *
 * For the Inventory beta — the redesign and inventory results in global search,
 * which both read `UserStore.isInventoryPilot` — this list is OR-ed with the
 * PostHog `inventory-beta` experiment: whoever is named here
 * stays in regardless of how PostHog assigns them, which is also what covers
 * the window before flags resolve and PostHog being unreachable. Add NEW
 * testers in PostHog rather than here.
 *
 * Lives in constants, NOT in `helpers/featureFlags.js`, because `UserStore`
 * reads it too (for `isInventoryPilot`) and that helper imports the store —
 * putting the list there would be a circular import. Constants import nothing,
 * so both sides can share one list.
 *
 * Compared lower-cased on both sides, so entries can be written however the
 * person writes their own address.
 */
export const INVENTORY_PILOT_EMAILS = [
  // CollX
  'ryan@collx.app',
  'mitchell@collx.app',
  'ted@collx.app',
  'dshaw@collx.app',
  'dean@collx.app',
  // Team
  // 'kyle@hikyle.co',
  'cass@cardlens.com',
  'roman18888@gmail.com',
  'vinkmitchell5@gmail.com',
  'sofia@meremortals.ai',
  'station27cards@hotmail.com',
  // Dealers
  'dexterwinkler@comcast.net',
  'tjfitz2@yahoo.com',
  'grumpz@grumpzsportscards.com',
  'jessica.nehr@gmail.com',
  'kniqknaqzllc@gmail.com',
  'montereysportscards@gmail.com',
]

/** True when `email` is on the pilot list. Case- and whitespace-insensitive. */
export const isPilotEmail = (email) => {
  const normalized = String(email || '').trim().toLowerCase()

  return !!normalized && INVENTORY_PILOT_EMAILS.some(entry => entry.toLowerCase() === normalized)
}
